import { common } from './chunks/common';
import { microbiome } from './chunks/microbiome';
import { bloodmarkers } from './chunks/bloodmarkers';
import { ui } from './chunks/ui';

export const translationEN = {
  ...common,
  ...microbiome,
  ...bloodmarkers,
  ...ui,
};
